export const THIRTY_TO_SIXTY_DAYS = '30 to 60 Days Ago';
export const SIXTY_TO_NINETY_DAYS = '60 to 90 Days Ago';
export const NINETY_TO_ONEEIGHTY_DAYS = '90 to 180 Days Ago';
export const DAYS_AGO_CUSTOM = 'Custom';
export const THIRTY = 30;
export const NINE = 9;
export const SIXTY = 60;
export const NINETY = 90;
export const ONEHUNDREDEIGHTY = 180;
export const UPDATEISRENGAGEMENT = 'UPDATEISRENGAGEMENT';
export const count = { ZERO: 0, ONE: 1 };
